export default __webpack_public_path__ + "static/media/Flower.4a4d93ba.svg";